import {Box, Grid, LogoSuite, Text, Tiles} from '@primer/react-brand/esm'
import type {LogoSuiteLogoBarProps, LogoSuiteProps} from '@primer/react-brand/esm'
import {t} from '@github-ui/swp-core/lib/utils/localization'
import {Logo} from '../FlexSuiteLogos/Logo'
import {getTileLink} from '../FlexSuiteLogos/tile-links'
import styles from './FlexSuiteIntroLogos.module.css'

export type IntroLogoLayout = 'logobar' | 'tiles'
export type IntroLogobarOptions = Pick<LogoSuiteLogoBarProps, 'variant' | 'marquee' | 'marqueeSpeed' | 'takeoverButton'>
export type IntroLogoSuiteOptions = Pick<LogoSuiteProps, 'variant'>

export type FlexSuiteIntroLogosProps = {
  heading?: string
  logos?: string[]
  layout?: IntroLogoLayout
  logobarOptions?: IntroLogobarOptions
  logoSuiteOptions?: IntroLogoSuiteOptions
  hideHeading?: boolean
  hasTopBorder?: boolean
}

export function FlexSuiteIntroLogos({
  heading,
  logos,
  layout = 'logobar',
  logobarOptions,
  logoSuiteOptions,
  hideHeading = true,
  hasTopBorder = false,
}: FlexSuiteIntroLogosProps) {
  if (!logos?.length) return null

  if (layout === 'tiles') {
    return (
      <Box marginBlockStart={48}>
        <Grid data-testid="intro-tiles">
          <Grid.Column>
            {heading ? (
              hideHeading ? (
                <Text as="p" size="200" variant="muted" align="center" className="sr-only">
                  {heading}
                </Text>
              ) : (
                <Box paddingBlockEnd={{narrow: 'spacious', regular: 64}} paddingBlockStart="spacious">
                  <Text as="p" size="200" variant="muted" align="center">
                    {heading}
                  </Text>
                </Box>
              )
            ) : null}
            <Tiles variant="gridlines" layout="compact">
              {logos.map(logo => (
                <Tiles.Item key={logo} name={logo} href={getTileLink(logo)} data-testid={`intro-tile-${logo}`}>
                  <Logo name={logo} />
                </Tiles.Item>
              ))}
            </Tiles>
          </Grid.Column>
        </Grid>
      </Box>
    )
  }

  const marquee = logobarOptions?.takeoverButton ? false : logobarOptions?.marquee

  return (
    <LogoSuite
      data-testid="intro-logobar"
      align="center"
      variant={logoSuiteOptions?.variant}
      className={hasTopBorder ? styles.logobarTopBorder : undefined}
    >
      <LogoSuite.Heading visuallyHidden={hideHeading || !heading}>{heading || t('Logos')}</LogoSuite.Heading>
      <LogoSuite.Logobar
        variant={logobarOptions?.variant}
        marquee={marquee}
        marqueeSpeed={logobarOptions?.marqueeSpeed}
        takeoverButton={logobarOptions?.takeoverButton}
      >
        {logos.map(logo => (
          <Logo key={logo} name={logo} />
        ))}
      </LogoSuite.Logobar>
    </LogoSuite>
  )
}
